const flashMessageReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_FLASH_MESSAGE':
            return {
                ...state,
                flashMessage: action.flashMessage
            }
        default:
            return state
    }
}

export default flashMessageReducer


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessageReducers.js